import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { interval, map, Observable, take } from 'rxjs';

import { CopyService } from '@amfam/shared/utility/shared-services';
import { DsModalService } from '@amfam/ui-kit';

export type ExitType = 'timeout' | 'user';

@Component({
  selector: 'amfam-phoenix-payment-timeout-modal',
  templateUrl: './phoenix-payment-timeout-modal.component.html',
  styleUrls: ['./phoenix-payment-timeout-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PhoenixPaymentTimeoutModalComponent implements OnInit {
  @Output() exitEvent = new EventEmitter<ExitType>();

  continueCopy = this.copyService.getCopy('shared.continueBtn');
  exitCopy = this.copyService.getCopy('shared.exitBtn');
  modalId = 'phoenixPaymentTimeoutModal';
  totalTime = 10 * 60; // in seconds
  timeLeft = this.totalTime;
  timeLeftString$: Observable<string>;
  userClosedModal = false;

  constructor(
    private copyService: CopyService,
    private modalService: DsModalService
  ) {}

  ngOnInit(): void {
    this.startTimer();
  }

  startTimer() {
    this.timeLeftString$ = interval(1000).pipe(
      take(this.totalTime + 1),
      map(elapsedSeconds => {
        this.timeLeft = this.totalTime - elapsedSeconds;
        const mins = Math.floor(this.timeLeft / 60);
        const secs = this.timeLeft - mins * 60;
        const timeLeftString = `${mins}:${secs < 10 ? `0${secs}` : secs}`;

        if (this.timeLeft <= 90 && !this.userClosedModal) {
          this.modalService.open(this.modalId);
        }

        if (this.timeLeft <= 0 && this.userClosedModal) {
          this.close('timeout');
        }

        return timeLeftString;
      })
    );
  }

  handleContinue() {
    this.close('timeout');
  }

  handleClose() {
    this.close('timeout');
  }

  handleExit() {
    this.close('user');
  }

  private close(exitType: ExitType) {
    this.modalService.close(this.modalId);
    this.userClosedModal = true;
    if (exitType === 'user') {
      this.exitEvent.emit('user');
    } else if (this.timeLeft <= 0) {
      this.exitEvent.emit('timeout');
    }
  }
}
